/** 検索語をそのままサーバーへ投げない。trim して落ち着いてから返す。
 *
 * 1文字ごとに問い合わせると、打っている途中の語で一覧が何度も入れ替わる。
 * queryKey にはこの戻り値を使う(生の入力を使うと打鍵ごとにキャッシュが増える)。
 */
import { useEffect, useState } from "react";

export const SEARCH_DEBOUNCE_MS = 300;

export function useDebounced(value: string, delay: number = SEARCH_DEBOUNCE_MS): string {
  const trimmed = value.trim();
  const [out, setOut] = useState(trimmed);
  useEffect(() => {
    const timer = setTimeout(() => setOut(trimmed), delay);
    return () => clearTimeout(timer);
  }, [trimmed, delay]);
  return out;
}
